<div class="subbanner">
    <div class="container position-relative">
      <div class="subbanner__title">
        <h1 class="primary-title">News and Articles</h1>
      </div>
    </div>
  </div>

<div class="container-fluid padding-section">
    <div class="new-artical">
        <div class="container">
            <ul class="new-artical__list list-unstyled">
                <li *ngFor="let item of articleItem; index as i"
                    [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
                    <!-- <a [href]="item.image" target="_blank"> -->
                    <img [src]="item.image" [alt]="item.image" width="395" height="250" loading="lazy" (click)="showLightbox(i)">
                    <!-- </a> -->
                </li>
            </ul>
            <ng-image-fullscreen-view [images]="articleItem" [imageIndex]="currentIndex" [show]="showFlag"
                (close)="closeEventHandler()"></ng-image-fullscreen-view>

            <!-- <ul class="new-artical__list list-unstyled">

                <li *ngFor="let item of items; index as i">
                    <img [lightbox]="i" width="100%" [src]="item.data.thumb">
                </li>

            </ul> -->
        </div>
    </div>